export enum TaskTypeModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
